import React from 'react';
import DatosfijosPresentacion from '../../components/datosfijos/Presentacion';

const Presentacion: React.FC = () => {
  return (
    <div style={{ padding: '20px', textAlign: 'center', alignItems: 'center', justifyContent: 'center' }}>
      <DatosfijosPresentacion />
    </div>
  );
};

export default Presentacion;